<template>
  <el-upload
    :limit="1"
    :action="uploadURL"
    :headers="headers"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
    accept=".zip, .rar"
  >
    <el-button type="primary" size="small">点击上传</el-button>
  </el-upload>
</template>

<script>
import baseUrl from "../api/baseUrl";

export default {
  data () {
    return {
      imageUrl: "",
      uploadURL: baseUrl + 'api/archive/upload',
      headers: {
        token: sessionStorage.getItem('token')
      },
    }
  },
  methods: {
    // 上传成功
    handleAvatarSuccess2 (res, file) {
      this.$message.success(res.data);
    },
    // 上传之前
    beforeAvatarUpload2 (file) {
      const isZip = file.type === 'application/zip' || file.type === 'application/x-rar-compressed' || file.name.endsWith('.zip') || file.name.endsWith('.rar');
      if (!isZip) {
        this.$message.error('只允许上传 ZIP 或 RAR 文件');
        return false; // 阻止文件上传
      }
      return true;
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-upload {
  width: 259px;
  height: 147px;
  display: flex;
  align-items: center;
  justify-content: center;
  .avatar {
    max-height: 100%;
    max-width: 100%;
  }
}
</style>
